// GeoJSON 파일 설정
export interface GeoJSONConfig {
  filename: string;
  name: string;
  color: string;
  opacity: number;
  visible: boolean;
}

export const geojsonFiles: GeoJSONConfig[] = [
  {
    filename: 'yeosu_vts.geojson',
    name: '여수 VTS',
    color: '#ff0000',
    opacity: 0.5,
    visible: true
  }
  // 새로운 GeoJSON 파일을 추가할 때 여기에 설정을 추가하면 됩니다
  // {
  //   filename: 'new_file.geojson',
  //   name: '새로운 레이어',
  //   color: '#00ff00',
  //   opacity: 0.3,
  //   visible: true
  // }
];

// 색상 팔레트 (자동 색상 할당용)
export const colorPalette = [
  '#ff0000', // 빨간색
  '#00ff00', // 초록색
  '#0000ff', // 파란색
  '#ffff00', // 노란색
  '#ff00ff', // 마젠타
  '#00ffff', // 시안
  '#ff8800', // 주황색
  '#8800ff', // 보라색
  '#008800', // 진한 초록색
  '#880000', // 진한 빨간색
];
